import React, { useEffect, useContext } from "react";
import { Route, withRouter } from "react-router-dom";
import $ from "jquery";
import AOS from "aos";

import PsContext from "../../context";
import Footer from "./footer/footer";
import FooterBottom from "./footer/footerBottom";
import HeaderLogo from "./header/headerLogo";
// import Slider from "./sliderstatic/slider"
import TopHeader from "./header/topHeader";
import TopMenu from "./header/topMenu";

import Routes from "../index";
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import SideBar from "./sideBar";
import { SuperSEO } from "react-super-seo";
import FooterButton from "./footer/footerButton";
import SettingsOffCanvas from "./settingsOffCanvas";

const DefaultLayout = (props) => {
  const context = useContext(PsContext);

  useEffect(() => {
    context.loadSettings();
  }, []);

  useEffect(() => {
    AOS.init({
      //offset: 200,
      //duration: 600,
      easing: "ease-in-sine",
      delay: 200,
      once: false,
    });

    $("html, body").animate({ scrollTop: 0 });
  }, [props.match.path, props.match.params]);

  const themeStyles = `
    .ps__top__menu{
      background-color:${context.settingValue(
        "web_site_header_bgcolor"
      )} !important;    
    }
  `;

  return (
    <>
      <SuperSEO title={context.settingValue("web_site_meta_title")} lang="en" />
      <style>{themeStyles}</style>

      <HeaderLogo />

      <TopMenu />

      {/*Routes.defaultlayout.map((item) => (
        <Route path={item.path} component={item.component} exact={item.exact} />
      ))*/}
      <Switch>
        {Routes.defaultlayout.map((item, i) => {
          return (
            <Route
              path={item.path}
              component={item.component}
              exact={item.exact}
            />
          );
        })}
      </Switch>

      <SettingsOffCanvas />

      <Footer />
      <FooterButton />
      <FooterBottom />
    </>
  );
};

export default withRouter(DefaultLayout);
